var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLockGold = function SvgIconLockGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166 88H54a8 8 0 0 0-8 8v82a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8V96a8 8 0 0 0-8-8Z",
    fill: "#FFAD24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 135.75a6.5 6.5 0 1 0-13 0V149a6.5 6.5 0 1 0 13 0v-13.25Z",
    fill: "#CA7300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 140.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Z",
    fill: "#CA7300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 34c-18.75 0-34 15.25-34 34v31.09c0 4.87 3.95 8.82 8.82 8.82s8.82-3.95 8.82-8.82V68c0-9.03 7.34-16.37 16.37-16.37 9.03 0 16.37 7.34 16.37 16.37v31.09c0 4.87 3.95 8.82 8.82 8.82s8.82-3.95 8.82-8.82V68c0-18.75-15.25-34-34-34H110Z",
    fill: "#FFAD24"
  })));
};
export default SvgIconLockGold;